<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Market Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Market Products",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Market Products",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      unitmodal_id: "",
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "image",
          sortable: true,
          label: "IMAGE",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "product_category",
          sortable: true,
          label: "Category",
        },
        {
          key: "quantity",
          sortable: true,
          label: "IN STOCK",
        },
        {
          key: "unitname",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "selling_price",
          sortable: true,
          label: "SELLING PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "image",
          sortable: true,
          label: "IMAGE",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "product_category",
          sortable: true,
          label: "Category",
        },
        {
          key: "quantity",
          sortable: true,
          label: "IN STOCK",
        },
        {
          key: "unitname",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "selling_price",
          sortable: true,
          label: "SELLING PRICE",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },

      ],
      json_fields: {
        CATEGORY: "product_category",
        PRODUCT_NAME: "name",
        UNITS: "unitname",
        QUANTITY: "quantity",
        SELLING_PRICE: "selling",
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      is_uploading: false,
      nameError: "",
      unitError: "",
      categoryError: "",
      productError: "",
      sellingPriceError: "",
      UnitProductunitError: "",
      imageError: "",

      transfer: {
        branch: "",
      },
      // edit product
      editdata: {
        name: "",
        selling_price: "",
        image: "",
        id: "",
      },
      // delete product
      deletedata: {
        name: "",
        id: "",
      },

      filterProducts: {
        branch_id: 0
      }

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("marketplace", ["saveStatus", "filterStatus", "Units", "MarketCategories", "MarketProducts"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "branchid", "Branches"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.MarketProducts ? this.MarketProducts.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.MarketProducts ? this.MarketProducts.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.closeModal(this.modal_id);
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchProducts: "marketplace/fetchMarketProducts",
      FetchUnits: "marketplace/fetchUnits",
      EditProduct: "marketplace/editMarketProduct",
      DeleteProduct: "marketplace/deleteMarketProduct",
      FetchCategories: "marketplace/fetchMarketCategories",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    resetEdit() {
      this.editdata.name = "";
      this.editdata.selling_price = "";
      this.editdata.image = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.categoryError = "";
      this.unitError = "";
      this.productError = "";
      this.sellingPriceError = "";
      this.imageError = "";
      this.UnitProductunitError = "";
      this.UnitqtyError = "";
      this.UnitsellingPriceError = "";
    },

    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.selling_price = data.item.selling_price;
      this.editdata.image = data.item.image;
      this.editdata.id = data.item.id;
    },
    editProduct(modalId) {
      this.modal_id = modalId;
      this.EditProduct(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    deleteProduct(modalId) {
      this.modal_id = modalId;
      this.DeleteProduct(this.deletedata);
    },
    //== close modal
    closeModal(modalId) {
      this.resetError();
      this.resetEdit();
      this.resetDelete();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    //== close modal
    closeUnitModal(modalId) {
      this.resetUnitError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // Fetch Pdts
    FilterProducts() {
      this.FetchProducts(this.filterProducts);
    },

    handleImageUpload(event) {
      const file = event.target.files[0];

      if (!file) return;

      // Validate image size (> 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.imageError = "Image must be less than 2MB";
        this.editdata.image = null;
        return;
      }

      this.imageError = "";
      this.editdata.image = file;
    },

    thousandSeparator(value) {
      if (!value) return "";

      return value
        .toString()
        .replace(/[^\d.]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    addSellCommas() {
      this.editdata.selling_price = this.thousandSeparator(
        this.editdata.selling_price
      );
    },
  },
  created() {
    this.FetchProducts(this.filterProducts);
    this.FetchUnits();
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterProducts.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="FilterProducts()">
                </model-list-select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="MarketProducts ? MarketProducts : []" :fields="branchid == 0 ? fields1 : fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(selling_price)="data">
                  {{ data.item.selling_price.toLocaleString() }}
                </template>
                <template #cell(image)="data">
                  <img :src="data.item.image" alt="Image" class="img-thumbnail" :height="100" :width="100"/>
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button v-if="MyUserPerm.edit_products == 1" size="sm" variant="primary"
                      v-b-modal.edit-product-modal @click="showEditModal(data)"><i class="fa fa-edit"></i>
                      Edit
                    </b-button>
                    <b-button v-if="MyUserPerm.delete_products == 1" size="sm" variant="danger"
                      v-b-modal.delete-product-modal @click="showDeleteModal(data)"><i class="fa fa-trash"></i>
                      Delete</b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader v-if="!MarketProducts" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- edit modal starts -->
    <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Product {{ editdata.name }}</template>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label>Product Name<span class="text-danger">*</span></label>
            <div class="input-group">
              <input type="text" class="form-control" @input="resetError()" v-model="editdata.name" />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-3">
            <label>Selling Price <span class="text-danger">*</span></label>
            <div class="input-group">
              <input type="text" placeholder="Enter Product Unit Selling Price" class="form-control"
                v-model="editdata.selling_price" @input="addSellCommas()"/>
            </div>
            <div class="text-danger" v-if="sellingPriceError">
              <em>{{ sellingPriceError }}</em>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label>
              Product Image
              <span class="text-danger">*</span>
            </label>
            <input
              type="file"
              class="form-control"
              accept="image/*"
              @change="handleImageUpload"
            />

            <small class="text-muted">
              Image must be less than 2MB
            </small>

            <div class="text-danger" v-if="imageError">
              <em>{{ imageError }}</em>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('edit-product-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editProduct('edit-product-modal')"> <i
            class="fa fa-check"></i>
          Save Changes
          <b-spinner v-if="saveStatus" variant="light" small label="Saving"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
      footer-bg-variant="danger" footer-text-variant="danger" id="delete-product-modal" hide-footer
      @hidden="resetDelete">
      <template #modal-title> Delete Product {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Product? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          @click="closeModal('delete-product-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteProduct('delete-product-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="saveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>